var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_607",
    "data-name": "Ret\\xE2ngulo 607",
    width: 24,
    height: 21,
    transform: "translate(0 0)",
    fill: "#004056"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1540",
    "data-name": "Grupo 1540",
    transform: "translate(0 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1539",
    "data-name": "Grupo 1539",
    transform: "translate(0 -0.08)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M.94,130.018a.94.94,0,0,1-.94-.94V123.44a.94.94,0,1,1,1.88,0v5.639a.94.94,0,0,1-.94.94",
    transform: "translate(0 -115.884)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M70.94,83.157a.94.94,0,0,1-.94-.94V70.94a.94.94,0,1,1,1.88,0V82.217a.94.94,0,0,1-.94.94",
    transform: "translate(-66.241 -66.203)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M140.94,130.018a.94.94,0,0,1-.94-.94V123.44a.94.94,0,1,1,1.88,0v5.639a.94.94,0,0,1-.94.94",
    transform: "translate(-132.482 -115.884)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M210.94,67.536a.94.94,0,0,1-.94-.94V53.44a.94.94,0,1,1,1.88,0V66.6a.94.94,0,0,1-.94.94",
    transform: "translate(-198.723 -49.643)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M280.94,20.675a.94.94,0,0,1-.94-.94V.94a.94.94,0,1,1,1.88,0v18.8a.94.94,0,0,1-.94.94",
    transform: "translate(-264.964 0.037)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M350.94,83.157a.94.94,0,0,1-.94-.94V70.94a.94.94,0,1,1,1.88,0V82.217a.94.94,0,0,1-.94.94",
    transform: "translate(-331.205 -66.203)",
    fill: "#004056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    "data-name": "Caminho 820",
    d: "M420.94,145.639a.94.94,0,0,1-.94-.94V140.94a.94.94,0,1,1,1.88,0V144.7a.94.94,0,0,1-.94.94",
    transform: "translate(-397.446 -132.444)",
    fill: "#004056"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon-audio.8c7d99d7ea41666a1d9961f3db1ca71e.svg";
export { ForwardRef as ReactComponent };